<template>
  <div class="block-control">
    <button class="block-control__button">
      <span @click="sendHubspot">Send to the HubSpot</span>
    </button>
    <button @click="getTxt" class="block-control__button">
      <span>Get the description</span>
    </button>
    <button @click="getPdf" class="block-control__button">
      <span>Print quote</span>
      <!-- <span>Save as a PDF file</span> -->
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const estimateStore = useNewEstimateStore();
const estimate = computed(() => estimateStore.estimate);

function getPdf() {
  estimateStore.save().then(() => {
    console.debug("get pdf report");
    window.open(
      `/api/estimates/${estimate.value.code}/report?format=pdf`,
      "_blank",
    );
  });
}

function getTxt() {
  estimateStore.save().then(() => {
    console.debug("get txt report");
    window.open(
      `/api/estimates/${estimate.value.code}/report?format=txt`,
      "_blank",
    );
  });
}

async function sendHubspot() {
  estimateStore.save();
  // const data = await estimateStore.sendHubspot();
  // todo check for success
  // if (data.status === "success") {
  //   window.alert("Data successfully sent");
  // } else {
  //   window.alert("Data sent error");
  // }
}
</script>

<style scoped>
.block-control {
  display: flex;
  justify-content: space-between;
  column-gap: 20px;
  margin-top: 20px;
  padding-bottom: 32px;
  border-bottom: 1px solid #d2d8e3;
}
.block-control__button {
  display: inline-block;
  width: 100%;
  padding: 17px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  border-radius: 30px;
  border: 1px solid #d2d8e3;
  color: #2491eb;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}
.block-pdf {
  min-height: 500px;
  border-radius: 10px;
  border: 1px dashed #404d63;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.block-pdf__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
}
.block-pdf__wrapper h3 {
  color: #404d63;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
</style>
